module.exports = "<app-map></app-map>\n<!--<app-index-about></app-index-about>\n<app-footer></app-footer>-->"